import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {CrownFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";

export abstract class AChallenge extends ABusiness {
    readonly icon = () => h(CrownFilled, {style: 'color:#1677ff'});
    readonly title = '挑战';
    readonly description = '用小成本奖品作为杠杆，撬动朋友圈的裂变式传播。';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {
            active: [{value: 'praise', label: '邀请有礼'}, {value: 'task', label: '任务式'}],
            preheating: [{value: 'praise', label: '邀请有礼'}, {value: 'task', label: '任务式'}],
            finished: []
        }[status]
    }
}
